export default __webpack_public_path__ + "static/media/close-btn.cb5d7eaa.svg";